<template>
    <a-modal v-model="visible" width="700px" :title="modalTitle" :footer="null" centered @cancel="handleCancelEvent" class="modal-box">
        <a-spin tip="Loading..." :spinning="loading" style="width: 100%">
            <a-form class="page-content-edit" ref="ruleForm" :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-item hidden :label="$t('mobileConfig.banner_info.column_id' /* 栏目id */)">
                    <a-input autocomplete="off" v-decorator="['id']" />
                </a-form-item>
                <!-- 标题 -->
                <a-form-item :label="$t('mobileConfig.banner_info.title' /* 标题 */)" class="mb10">
                    <a-input autocomplete="off" v-decorator="['title', { rules: [{ required: true, message: $t('mobileConfig.banner_info.title_required' /* 请输入标题 */) }] }]" />
                </a-form-item>
                <!-- 焦点图 -->
                <a-form-item
                    :label="$t('mobileConfig.banner_info.image' /* 焦点图 */)"
                    :extra="$t('mobileConfig.banner_info.image_tips' /* 支持JPG、GIF、PNG图片文件, 建议尺寸 900*500 */)"
                    class="mb10 upload-form-item"
                >
                    <a-upload
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        :action="uploadImageUrl"
                        :data="{ type: 1 }"
                        :before-upload="beforeUpload"
                        :headers="uploadHeaders"
                        @change="handleChange($event, { fieldName: 'pic_url', loading: 'loading_image' })"
                    >
                        <input type="hidden" v-decorator="['pic_url', { rules: [{ required: true, message: $t('mobileConfig.banner_info.image_required' /* 请上传图片 */) }] }]" />
                        <a-spin v-if="form.getFieldValue('pic_url')" :spinning="loading_image">
                            <img style="max-width: 100%" :src="form.getFieldValue('pic_url') | urlFilter(250)" alt="file" />
                        </a-spin>
                        <div v-else>
                            <a-icon :type="loading_image ? 'loading' : 'plus'" />
                            <div class="ant-upload-text">{{ $t('mobileConfig.banner_info.upload_image' /* 上传图片 */) }}</div>
                        </div>
                    </a-upload>
                    <a-button @click="handleRemoveEvent('pic_url')" v-if="form.getFieldValue('pic_url')">{{ $t('mobileConfig.banner_info.clear_image' /* 清 除 */) }}</a-button>
                </a-form-item>
                <!-- 链接 -->
                <a-form-item :label="$t('mobileConfig.banner_info.link' /* 链接 */)" :extra="$t('mobileConfig.banner_info.link_required' /* 请输入带有 http:// 或 https:// 的链接 */)" class="mb10">
                    <a-input autocomplete="off" v-decorator="['link_url']" />
                </a-form-item>
                <!-- 排序 -->
                <a-form-item :label="$t('mobileConfig.banner_info.sort' /* 排序 */)" class="mb10">
                    <a-input autocomplete="off" type="number" v-decorator="['sort']" />
                </a-form-item>

                <div class="fixed-footer mt30 t-c">
                    <a-button @click="handleSubmitEvent" style="min-width: 150px" type="primary">{{ $t('mobileConfig.banner_info.submit' /* 立即提交 */) }}</a-button>
                </div>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
import pick from 'lodash.pick';
import userApi from '@/request/apiList';
// 表单字段
const fields = ['id', 'title', 'pic_url', 'link_url', 'sort'];

export default {
    name: 'MobileConfigBannerInfo',
    props: {},
    data() {
        return {
            modalTitle: this.$t('web.new' /* 新增 */),
            visible: false,
            loading: true,

            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 17 }
            },

            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            loading_image: false,
            language: 'cn',
            form: this.$form.createForm(this)
        };
    },

    components: {},

    computed: {},

    methods: {
        // 上传修改
        handleChange(info, { fieldName, loading }) {
            if (info.file.status === 'uploading') {
                this[loading] = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    let obj = {};
                    obj[fieldName] = data.relative_path;
                    this.form.setFieldsValue(obj);
                } else {
                    this.$message.error(message);
                }
                this[loading] = false;
            }
        },

        // 上传前
        beforeUpload(file) {
            return new Promise((resolve, reject) => {
                // 头像的验证
                let regFile = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
                if (!regFile) {
                    this.$message.error(this.$t('formConfig.only_upload_image' /* 您只能上传图像文件 */));
                    return reject(regFile);
                }
                return resolve(regFile);
            });
        },

        show(item) {
            this.visible = true;
            this.language = window.location.hash.match(/(cn|en)/g)[0];
            this.$nextTick(() => {
                // 防止表单未注册
                fields.forEach(v => this.form.getFieldDecorator(v));
                this.modalTitle = item?.title || this.$t('web.new' /* 新增 */);
                if (item) {
                    // 数据回显
                    this.form.setFieldsValue(pick(item, fields));
                }
                this.loading = false;
            });
        },

        // 取消
        handleCancelEvent() {
            this.form.resetFields();
            this.visible = false;
        },

        // 提交
        handleSubmitEvent() {
            this.form.validateFields((errors, values) => {
                if (!errors) {
                    this.loading = true;
                    console.log(values);
                    let data = {
                        language: this.language,
                        ...values
                    };
                    this.$request
                        .post({ url: 'getMobileBannerInfo', data })
                        .then(res => {
                            this.loading = false;
                            if (res.code == 200) {
                                this.$message.success(this.$t('formConfig.save_success' /* 保存成功 */));
                                this.$emit('refresh');
                                this.handleCancelEvent();
                            }
                        })
                        .catch(err => {
                            this.loading = false;
                        });
                }
            });
        },

        handleRemoveEvent(fieldName) {
            this.form.setFieldsValue({ [fieldName]: '' });
        }
    },
    created() {},
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
    }
};
</script>
<style lang="less" scoped>
.page-content-edit {
    .upload-form-item {
        /deep/.ant-form-item-children {
            .avatar-uploader {
                width: auto;
            }
            display: flex;
            align-items: flex-end;
            .ant-upload {
                margin-bottom: 0;
            }
        }
    }
}
</style>
